import axios from "axios";

import { OrgStructureDetailModel } from "@teamprevent/common/orgStructure/models";

class OrgStructureApi {

    private readonly apiUrl = "/api/OrgStructure";

    public async getAll(customerId: string, orgStructureId: string): Promise<OrgStructureDetailModel[]> {
        const response = await axios.get(`${this.apiUrl}/${orgStructureId}`);
        return response.data;
    }
}

export const orgStructureApi = new OrgStructureApi();
